<script>
import { formatGetTime } from '@utils/format-date'
import lazyLoadComponent from '@router/lazyload-component'
export default {
  components: {
    BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
    CountryCodePicker: () => lazyLoadComponent(import('@components/CountryCodePicker')),
  },
	props: {
    value: {
      type: Object,
      default: () => {}
    },
    accessType: {
      type: String,
      default: '',
    },
    hasAdminPermission: {
      type: [Array, Boolean],
      default: () => [] || false
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    isSpace: {
      type: Boolean,
      default: false
    }
	},
  mounted(){
  },
  data() {
    return {
      endDatePickerOptions: {
        disabledDate: (time) => {
          // check String or Date Object
          const selectedStartDate = this.value.takeOfficeDate instanceof Object ? this.value.takeOfficeDate : new Date(this.value.takeOfficeDate)
          return time < selectedStartDate
          // 下面是限定一年以後不給點選，先拔掉
          // const limitWith365Days = selectedStartDate.getTime() + 3600 * 1000 * 24 * 365
          // return time < selectedStartDate || time.getTime() >= limitWith365Days
        },
      },
    }
  },
  computed: {
    submitData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    submitRules() {
      const isTaiwan = this.value.phoneCode === '+886'
      return {
        avatar: [
          {
            required: true,
            message: '請上傳頭像',
            // trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: '請填寫姓名',
            trigger: 'blur',
          },
        ],
        // account: [
        //   { required: true, message: '請輸入 Email', trigger: 'blur' },
        //   { type: 'email', message: '請輸入正確的 Email 格式', trigger: 'blur' },
        // ],
        // secretCode: [
        //   {
        //     required: !this.isEditMode,
        //     message: '請輸入密碼',
        //     trigger: 'blur',
        //   },
        //   {
        //     validator: (rule, value, callback) => {
        //       const passwordPattern = /^\S{8,16}$/
        //       if (!passwordPattern.test(value)) {
        //         callback(new Error('請使用 8~16 個大小寫英文字母、數字與特殊符號組合'))
        //       }
        //       if (this.submitData.secretCodeConfirm !== '') {
        //         this.$refs.form.validateField('secretCodeConfirm')
        //       }
        //       callback()
        //     },
        //     trigger: 'blur',
        //   },
        // ],
        // secretCodeConfirm: [
        //   {
        //     required: true,
        //     validator: (rule, value, callback) => {
        //       if (!value) return callback(new Error('請再次輸入密碼'))
        //       const passwordValue = this.submitData.secretCode
        //       if (value !== passwordValue) {
        //         callback(new Error('兩次輸入的密碼不一致'))
        //       }
        //       callback()
        //     },
        //     trigger: 'blur',
        //   },
        // ],
        title: [
          {
            required: true,
            message: '請填寫職位',
            trigger: 'blur',
          },
        ],
        phoneCode: [
          {
            required: true,
            message: '請選擇電話國碼',
            trigger: 'change',
          },
        ],
        phoneNumber: [
          {
            required: true,
            message: '請填寫聯絡電話',
            trigger: 'blur',
          },
          {
            pattern: isTaiwan ? /^(02|03|04|049|05|06|07|08)\d{7,8}$|^09\d{8}$/ : '',
            message: '市話號碼格式請符合 02XXXXXXXX；手機號碼格式請符合 09XXXXXXXX',
            trigger: 'blur',
          },
        ],
        takeOfficeDate: [
          {
            validator: (rule, value, callback) => {
              if (this.submitData.takeOfficeDate) this.$refs.form.validateField('leaveOfficeDate')
              callback()
            },
            trigger: 'change',

          },
        ],
        leaveOfficeDate: [
          {
            validator: (rule, value, callback) => {
              if (this.submitData.takeOfficeDate && !!value) {
                const isSmallThanTakeOfficeDate = formatGetTime(this.submitData.takeOfficeDate) > formatGetTime(value)
                if (isSmallThanTakeOfficeDate) return callback(new Error('不得小於到職日期'))
              }
              callback()
            },
            trigger: 'change',
          },
        ],
        userGroupIds: [
          {
            required: true,
            message: '請選擇權限',
            // trigger: 'blur',
          },
        ],
        userGroupStoreIds: [
          {
            required: true,
            message: '請選擇負責分店',
            trigger: 'change',
          },
        ],
      }
    },
  }
}
</script>

<template>
  <div :class="[$style.pageContent, { [$style['isStyleEmployee']]: accessType === 'employee' }]">
    <el-form ref="form" :model="submitData" :rules="submitRules" label-position="top" class="el-form--floating"
      :class="$style.allPageStyle" :validate-on-rule-change="false">
      <div :class="[
      accessType !== 'employee' ? '' : '',
      $style.pageBaseInfo]">
        <el-col v-if="accessType !== 'employee'" :md="6">
          <el-form-item prop="avatar" class="imgPlacement errorTextCenter ">
            <BaseUpload 
              v-model="submitData.avatar" 
              resource="staff" 
              circle 
              suggest-size="128/128"
              :class="$style['actions--circle']"
              :more-width="true" :img-circle="true" />
          </el-form-item>
        </el-col>
        <el-row :gutter="10" style="width: 100%;">
          <h4 class="basicInfoForMainPart">基本資料</h4>
          <!-- accessType === 'staff' -->
          <el-col v-if="accessType !== 'employee'" :span="24">
            <!-- 人員 -> 基本資訊 -> staff 主要part -->
            <el-row :gutter="20" type="flex">
              <el-col :md="12">
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="submitData.name" />
                </el-form-item>
              </el-col>
              <el-col v-if="!hasAdminPermission" :md="12">
                <el-form-item label="帳號啟用" prop="block">
                  <el-switch v-model="submitData.block" active-text="啟用" inactive-text="停權" :active-value="0"
                    :inactive-value="1" :disabled="defaultValue.canBlock === 0"></el-switch>
                  <el-alert v-if="defaultValue.canBlock === 0" title="欲停權請先移轉隸屬此帳號的有效訂單" type="warning"
                    style="display: inline; margin-left: 20px" :closable="false" show-icon>
                  </el-alert>
                </el-form-item>
              </el-col>

              <el-col :md="12" v-show="!isSpace">
                <el-form-item label="聯絡電話" prop="phoneNumber">
                  <el-input v-model="submitData.phoneNumber"
                    class="is-border is-rounded bg-white is-short-input is-group__prepend-border">
                    <CountryCodePicker slot="prepend" v-model="submitData.phoneCode" />
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12" v-show="!isSpace">
                <el-form-item label="到職日期" prop="takeOfficeDate">
                  <el-date-picker v-model="submitData.takeOfficeDate" type="date" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :md="12" v-show="!isSpace">
                <el-form-item label="離職日期" prop="leaveOfficeDate">
                  <el-date-picker v-model="submitData.leaveOfficeDate" :picker-options="endDatePickerOptions"
                    type="date" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="職位" prop="title">
                  <el-input v-model="submitData.title" />
                </el-form-item>
              </el-col>

              <!-- <el-col v-if="accessType !== 'employee' && hasBranchPermission" :md="12">
                <el-form-item label="負責分店（可複選）" prop="userGroupStoreIds">
                  <el-checkbox-group v-model="submitData.userGroupStoreIds">
                    <el-checkbox v-for="store in cachedProducts" :key="store.id" :label="store.id">{{ store.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col> -->
            </el-row>
          </el-col>
        </el-row>
      </div>

      <el-row v-if="accessType === 'employee'" :gutter="40" type="flex">
        <el-col :span="24">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="submitData.name" />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="!isSpace">
          <el-form-item label="聯絡電話" prop="phoneNumber">
            <el-input v-model="submitData.phoneNumber" class="bg-white is-short-input">
              <CountryCodePicker slot="prepend" v-model="submitData.phoneCode" />
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="到職日期" prop="takeOfficeDate">
            <el-date-picker v-model="submitData.takeOfficeDate" type="date" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>


      <el-row :gutter="40" type="flex">
        <!-- 未來有機會打開，不要刪 -->
        <!-- <el-col v-if="accessType !== 'employee'" :md="12">
          <el-form-item label="Email" prop="account">
            <el-input v-model="submitData.account"/>
          </el-form-item>
        </el-col> -->

        <!-- 未來有機會打開，不要刪 -->
        <!-- <el-col v-if="accessType !== 'employee'" :md="12">
          <el-form-item label="指定權限" prop="userGroupIds" requierd>
            <el-checkbox-group v-model="submitData.userGroupIds" >
              <el-checkbox v-for="item in userGroupList" :key="item.id" :label="item.id" :disabled="item.id === 7">{{item.title}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col> -->

        <!-- 未來有機會打開，不要刪 -->
        <!-- <el-col v-if="isEditMode" :md="24">
          <el-button v-if="!passwordEditable" type="text" @click="passwordEditable = true">變更密碼</el-button>
          <el-button v-if="passwordEditable" type="text" @click="passwordEditable = false">取消變更密碼</el-button>
        </el-col> -->

        <!-- 未來有機會打開，不要刪 -->
        <!-- <el-col v-if="accessType !== 'employee'" :md="12">
          <el-form-item prop="maxCollision">
            <span slot="label" for=""
              >可同時服務幾位顧客
              <el-tooltip content="這位服務人員同一時段可預約的顧客人數，如果輸入2，則同一時段可供2人預約" placement="right"> <BaseIcon name="info-circle" /> </el-tooltip
            ></span>

            <el-input v-model="submitData.maxCollision" />
          </el-form-item>
        </el-col> -->

        <el-col :span="24" v-show="!isSpace">
          <el-form-item label="專長" prop="specialty">
            <el-input v-model="submitData.specialty" />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="!isSpace">
          <p v-if="accessType === 'employee'" class="itemTitle">服務證照</p>
          <el-form-item label="證照" prop="certificate">
            <el-input v-model="submitData.certificate" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <h4>介紹</h4>
          <el-form-item label="個人介紹" prop="description">
            <el-input v-model="submitData.description" type="textarea" class="bg-white is-border is-round"
              :autosize="{ minRows: 3 }" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
.pageContent {
  margin-bottom: 8rem;
  background-color: white;
  &.isStyleEmployee {
    margin-bottom: 0;
  }
  &:global {
    &.isStyleDialogComponent {
      margin-bottom: 0;
    }
  }
}
.pageBaseInfo {
  // background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  // padding: 20px;
  :global {
    .basicInfoForMainPart {
      padding-left: 20px;
    }

    .imgPlacement {
      display: flex;
      justify-content: center;
    }
  }
}

.isEmployeeMob {
  margin-top: 24px;

  @include max-md {
    margin-top: 100px;
  }

  @include max-lg {
    margin-top: 100px;
  }

  @include max-sm {
    margin-top: 100px;
  }
}
</style>